const dispatchWithPromise = (dispatch, action, payload, meta = {}) => {
  const dispatcher = new Promise((resolve, reject) =>
    dispatch(action(payload, { resolve, reject, ...meta })),
  );
  return dispatcher;
};

export default dispatchWithPromise;
